export const tabs = [
  {
    key: 'guidelines',
    icon: 'uil:file-alt',
    title: 'Content Gaps',
  },
  {
    key: 'outline',
    icon: 'uil:layer-group',
    title: 'Outlines',
  },
  {
    key: 'faq',
    icon: 'uil:globe',
    title: 'FAQs',
  },
]
